import { apiService } from './api';

/**
 * Case management service
 */
export const caseService = {
  /**
   * Get all cases for the current user
   * @param {string} token - Auth token
   * @returns {Promise<Array>} List of cases with assessment counts
   */
  getCases: async (token) => {
    return await apiService.get('/api/cases', token);
  },

  /**
   * Get single case with full assessment history
   * @param {string} caseId - Case ID
   * @param {string} token - Auth token
   * @returns {Promise<Object>} Case details with assessments
   */
  getCase: async (caseId, token) => {
    return await apiService.get(`/api/cases/${caseId}`, token);
  },

  /**
   * Create new case
   * @param {string} name - Case name/initials
   * @param {string} token - Auth token
   * @returns {Promise<Object>} Created case object
   */
  createCase: async (name, token) => {
    return await apiService.post('/api/cases', { name }, token);
  },

  /**
   * Update case metadata
   * @param {string} caseId - Case ID
   * @param {Object} updates - Fields to update (name, metadata)
   * @param {string} token - Auth token
   * @returns {Promise<Object>} Updated case object
   */
  updateCase: async (caseId, updates, token) => {
    return await apiService.put(`/api/cases/${caseId}`, updates, token);
  },

  /**
   * Delete case (soft delete)
   * @param {string} caseId - Case ID
   * @param {string} token - Auth token
   * @returns {Promise<Object>} Deletion confirmation
   */
  deleteCase: async (caseId, token) => {
    return await apiService.delete(`/api/cases/${caseId}`, token);
  }
};

